import i18n from '@/lang/index'
export const columnData = [
    {
        key: 'sn',
        text: i18n.t('invoicesCenter.configtransSn'),
        width: '230px',
        fixed: 'left'
    },
    {
        key: 'stateDesc',
        text: i18n.t('invoicesCenter.configtransStatedesc'),
        width: '200px',
        fixed: 'left',
        remind: {
            text: `
                ${i18n.t('invoicesCenter.statedescShipmentout')}<br/>
                ${i18n.t('invoicesCenter.statedescSigned')}<br/>
                ${i18n.t('invoicesCenter.statedescChecking')}<br/>
                ${i18n.t('invoicesCenter.statedescInstock')}<br/>
                ${i18n.t('invoicesCenter.statedescCancelapply')}<br/>
          `,
            style: {
                width: '400px',
                'font-size': '12px',
                'text-align': 'left',

            }
        },
        template: () => {
            return `
              <div style="display:flex;align-items:center;">
                  <span v-if="row.state == 0" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#F8475F;"></span>
                  <span v-else-if="[4,6,8,12,14].includes(+row.state)" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#43D268;"></span>
                  <span v-else-if="[5,7,11].includes(+row.state)" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#FF9000;"></span>
                  <span v-else-if="[1,9,10].includes(+row.state)" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#067CF2;"></span>
                  <span v-else-if="row.state == 2" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#BD73D3;"></span>
                  <span v-else-if="row.state == 19" style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#F8475F;"></span>
                  <span v-else style="width:10px;height:10px;border-radius:35%;margin-right:10px;background:#999;"></span>
                  <span>{{row.stateDesc}}</span>
              </div>
          `
        }
    },
    {
        key: 'ifDiscrepancy',
        text: i18n.t('invoicesCenter.configtransIfdiscrepancy'),
        width: '270px',
        template: () => {
            return `
                <div>{{row.ifDiscrepancy === 'Y' ? '${i18n.t('invoicesCenter.configtransYes')}' : '${i18n.t('invoicesCenter.configtransNo')}'}}</div>
            `
        }
    },
    {
        key: 'outMarketName',
        text: i18n.t('invoicesCenter.configtransOutmarketname'),
        width: '200px'
    },
    { key: 'inMarketName', text: i18n.t('invoicesCenter.configtransInmarketname'), width: '200px' },

    { key: 'totalNum', text: i18n.t('invoicesCenter.configtransTotalnum'), width: '200px',
     template: (e, row) => {
        return `<span>{{row.totalNum==='0'?'':row.totalNum}}<span>`
    } },
    { key: 'outNum', text: i18n.t('invoicesCenter.configtransOutnum'), width: '200px',
     template: (e, row) => {
        return `<span>{{row.outNum==='0'?'':row.outNum}}<span>`
    } },
    { key: 'outPackageNum', text: i18n.t('invoicesCenter.configtransOutpackagenum'), width: '160px',
        template: (e, row) => {
            return `<span>{{row.outPackageNum==='0'?'':row.outPackageNum}}<span>`
        }
    },
    {
        key: 'outNumDifference',
        text: i18n.t('invoicesCenter.configtransOutnumdifference'),
        width: '200px',
        template: (e, row) => {
            return `<span style="color:red">{{row.outNumDifference==='0'?'':row.outNumDifference}}<span>`
        }
    },
    { key: 'inNum', text: i18n.t('invoicesCenter.configtransInnum'), width: '200px',
     template: (e, row) => {
        return `<span>{{row.inNum==='0'?'':row.inNum}}<span>`
    } },
    { key: 'logisticPackageCheckNum', text: i18n.t('invoicesCenter.configtransLogisticpackagechecknum'), width: '200px',
        template: (e, row) => {
            return `<span>{{row.logisticPackageCheckNum==='0'?'':row.logisticPackageCheckNum}}<span>`
        }
    },
    {
        key: 'inNumDifference',
        text: i18n.t('invoicesCenter.configtransInnumdifference'),
        width: '200px',
        template: (e, row) => {
            return `<span  style="color:red">{{row.inNumDifference==='0'?'':row.inNumDifference}}<span>`
        }
    },
    { key: 'remark', text: i18n.t('invoicesCenter.configtransRemark'), width: '200px' },
    { key: 'createUserName', text: i18n.t('invoicesCenter.configtransCreateusername'), width: '200px' },
    {
        key: 'createTime',
        text: i18n.t('invoicesCenter.configtransCreatetime'),
        width: '160px',
    },
    { key: 'updateTime', text: i18n.t('invoicesCenter.configtransUpdatetime'), width: '160px' },
    { key: 'updateUserName', text: i18n.t('invoicesCenter.configtransUpdateusername'), width: '100px' }

]
export const options = {
    searchItem: [
        {
            id: '2',
            type: 'input',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.placeholderInvoicesno'),
            label: i18n.t('invoicesCenter.labelInvoicesno'),
            value: '',
            resField: 'invoicesNoList'
        },
        {
            id: 'ifDiscrepancy',
            type: 'select',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.placeholderSelect'),
            label: i18n.t('invoicesCenter.labelIfdiscrepancy'),
            value: '',
            resField: 'ifDiscrepancy',
            multiple: false,
            list: [
                { value: 'Y', name: i18n.t('invoicesCenter.configtransYes') },
                { value: 'N', name: i18n.t('invoicesCenter.configtransNo') }
            ]
        },
        {
            id: 'hasDiscrepancy',
            type: 'select',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.placeholderSelect'),
            label: i18n.t('invoicesCenter.labelHasdiscrepancy'),
            value: '',
            resField: 'hasDiscrepancy',
            multiple: false,
            list: [
                { value: 'Y', name: i18n.t('invoicesCenter.configtransYes') },
                { value: 'N', name: i18n.t('invoicesCenter.configtransNo') }
            ]
        },
        {
            id: '11',
            type: 'input',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.placeholderExpressno'),
            label: i18n.t('invoicesCenter.labelExpressno'),
            value: '',
            resField: 'expressNo'
        },
        {
            id: '1',
            type: 'select',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.placeholderState'),
            label: i18n.t('invoicesCenter.labelState'),
            value: ['9','10','11'],
            resField: 'state',
            multiple: true,
            list: [
                { name: i18n.t('invoicesCenter.stateShipmentout'), value: '9' },
                { name: i18n.t('invoicesCenter.stateSigned'), value: '10' },
                { name: i18n.t('invoicesCenter.stateChecking'), value: '11' },
                { name: i18n.t('invoicesCenter.stateInstock'), value: '14' },
                { value: '19', name: i18n.t('invoicesCenter.stateCancelapply') },
                { value: '0', name: i18n.t('invoicesCenter.stateCanceled') }
            ]
        },
        {
            id: '4',
            type: 'storeSelector',
            placeholder: i18n.t('invoicesCenter.placeholderOutmarket'),
            label: i18n.t('invoicesCenter.labelOutmarket'),
            // modelKey: 'Id',
            value: [],
            resField: 'outMarketIds'
        },
        {
            // id: 'goodsNo',
            // type: 'goodsNoSelector',
            // placeholder: '请选择货号',
            // label: '货号',
            // modelKey: 'goodsNo',
            // multiple: true, //单选
            // // value: '', //单选
            // value: [],//多选
            // resField: 'goodsNo'
            id: 'goodsNo',
            type: 'goodsNoSelector',
            placeholder: i18n.t('invoicesCenter.placeholderGoodsno'),
            label: i18n.t('invoicesCenter.labelGoodsno'),
            modelKey: 'goodsNo',
            multiple: true,
            value: '',
            inputShow: true,
            slectShow: false,
            resField: 'goodsNo'
        },
        // {
        //     id: '7',
        //     type: 'selectUser',
        //     size: 'small',
        //     clearable: true,
        //     placeholder: '请选择创建人',
        //     label: '创建人',
        //     value: '',
        //     resField: 'createUserId',
        //     list: [],
        //     filterable: true,
        //     remote: true
        // },
        {
            id: "UserInput",
            type: "input",
            size: "small",
            clearable: true,
            placeholder: i18n.t('invoicesCenter.placeholderCreateuser'),
            label: i18n.t('invoicesCenter.labelCreateuser'),
            value: "",
            resField: "createUserName",
        },
        {
            id: '8',
            type: 'daterange',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.placeholderCreatetime'),
            label: i18n.t('invoicesCenter.labelCreatetime'),
            value: '',
            resField: 'createTime',
            valueFormat: 'yyyy-MM-dd'
        },
        {
            id: '9',
            type: 'daterange',
            size: 'small',
            clearable: true,
            placeholder: i18n.t('invoicesCenter.placeholderUpdatetime'),
            label: i18n.t('invoicesCenter.labelUpdatetime'),
            value: '',
            resField: 'updateTime',
            valueFormat: 'yyyy-MM-dd'
        }
    ],
    // 确认按钮
    sureBtnVisable: true,
    sureBtnType: 'primary',
    sureBtnSize: 'medium',
    sureBtnText: i18n.t('invoicesCenter.btnSearch'),
    //重置按钮
    restBtnVisable: true,
    restBtnType: '',
    restBtnSize: 'medium',
    restBtnText: i18n.t('invoicesCenter.btnReset')
}
